export const BACKGROUND_IMAGE_CONTAINER_TEST_ID = 'background-image-container';
export const BACKGROUND_IMAGE_TEXT_TEST_ID = 'background-image-text';
export const BACKGROUND_IMAGE_SOURCE_TEST_ID = 'image-source-test-id';
